/*
⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Il est interdit de copier ou revendre cette section pour de l'usage commercial sans l'accord de l'auteur. Pour toute demande d'information, veuillez contacter maxime.crouin(at)gmail.com
⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (article L. 111-1 of the intellectual property code). It is forbidden to resell or duplicate this ressource for commercial use without permission of the author. For any information request, please contact maxime.crouin(at)gmail.com
*/

/**
 * Init
 */
dynamicSwatches();

/**
 * Swatches update on variant change
 */
function dynamicSwatches() {
  class DynamicSwatches extends HTMLElement {
    constructor() {
      super();
      this.product = this.classList.contains('product');
      if (!this.product)
        this.closest(MD.settings.swatches.parent).addEventListener('click', this.onSwatchTrigger.bind(this));
      this.linkOptions();
    }

    onSwatchTrigger(e) {
      if ('swatchesToggle' in e.target.dataset) {
        this.setAttribute('data-state', this.getAttribute('data-state') == 'close' ? 'open' : 'close');
      } else if (!this.querySelector('.item__swatches--fieldsets').contains(e.target)) {
        document.location = this.dataset.url;
      }
    }

    onVariantChange() {
      this.updateOptions();
      if (!this.hiddenFieldSet) {
        this.updateMasterId();
        if (this.currentVariant) {
          if (this.product) {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
          } else {
            this.submitForm(this.currentVariant.id);
          }
        }
      }
    }

    updateOptions() {
      this.hiddenFieldSet = this.querySelector('[data-swatches-option="hidden"]');
      if (this.hiddenFieldSet) {
        this.hiddenFieldSet.dataset.swatchesOption = 'visible';
        const swatchesWrapper = this.querySelector('.item__swatches--fieldsets');
        swatchesWrapper.scrollTop = swatchesWrapper.scrollHeight;
      } else {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        });
        this.updateLegends();
      }
    }

    updateLegends() {
      const legends = this.querySelectorAll('legend b');
      for (const [i, legend] of legends.entries()) {
        legend.textContent = this.options[i];
      }
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );

      if (!newMedia) return;
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      modalContent.prepend(newMediaModal);
      parent.prepend(newMedia);
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
      window.setTimeout(() => {
        parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' });
      });
    }

    updateURL() {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const form = this.closest('form[action="/cart/add"]');
      const formMasterId = form.querySelector('[name="id"]');
      if (!formMasterId)
        form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="id" value="${this.currentVariant}">`);
      formMasterId.value = this.currentVariant.id;
      formMasterId.dispatchEvent(new Event('change', { bubbles: true }));
    }

    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const prices = `${MD.settings.swatches.priceGroup}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = document.querySelector(prices);
          const source = html.querySelector(prices);
          if (source && destination) destination.innerHTML = source.innerHTML;
        });
    }

    submitForm(id) {
      fetch('/cart/add.js', {
        body: JSON.stringify({ id, quantity: 1 }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        method: 'POST',
      })
        .then((response) => response.json())
        .then((json) => {
          window.MaxDesign?.cartDrawer?.fetchCart();
          if (!this.product) this.resetOptions();
        })
        .catch(console.error);
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    linkOptions() {
      const swatches = this.querySelectorAll('fieldset');
      const cartesian = (a) => a.reduce((a, b) => a.flatMap((d) => b.map((e) => [d, e].flat())));
      const allOptions = [...swatches].map((swatch) => [...swatch.querySelectorAll('input')].map((input) => input.value));
      const variants = this.getVariantData();
      const controlVariants = cartesian(allOptions);
      const optionNumbers = [];
      const optionNumberToMap = {};

      // add undefined variants to improve options linking
      if (variants.length != controlVariants.length) {
        const undefinedVariants = controlVariants.filter((controlOptions) => {
          return variants
            .map((variant) => variant.options)
            .every((option) => {
              return !option.every((val, index) => val == controlOptions[index]);
            });
        });
        for (let [index, options] of undefinedVariants.entries()) {
          const undefinedDict = {
            available: false,
            options: undefinedVariants[index],
          };
          for (let [index, option] of options.entries()) undefinedDict[`option${index + 1}`] = option;
          variants.push(undefinedDict);
        }
      }

      function disableValuesInSwatch(swatch, values) {
        for (const value of values) {
          const elementToDisable = swatch.querySelector(`input[value="${value}"]`);
          if (elementToDisable) {
            elementToDisable.disabled = true;
          }
        }
      }

      function enableAllOtherValuesInSwatches(swatches) {
        for (const swatch of swatches) {
          for (const input of swatch.querySelectorAll('input')) {
            input.disabled = false;
          }
        }
      }

      for (const swatch of swatches) {
        const swatchOptionNumber = swatch.dataset.index;
        optionNumbers.push(swatchOptionNumber);
        optionNumberToMap[swatchOptionNumber] = swatch;

        swatch.addEventListener('change', () => {
          // trigger other variant changes methods
          this.onVariantChange();

          // reset all other options swatches
          enableAllOtherValuesInSwatches([...swatches].filter((swatch) => swatch.dataset.index != swatchOptionNumber));

          // set list of unavailable variants
          const currentValue = swatch.querySelector('input:checked').value;
          const unavailableVariantsWithNewValue = variants.filter((variant) => {
            return variant[swatchOptionNumber] === currentValue && !variant.available;
          });

          // filter list based on current variant
          const filteredUnavailableVariantsWithNewValue = unavailableVariantsWithNewValue.filter((variant) => {
            if (this.currentVariant) {
              const currentOtherOptionValues =
                swatches.length < 3
                  ? this.currentVariant.options
                  : this.currentVariant.options.filter((value) => value != currentValue);
              return currentOtherOptionValues.some((value) => variant.options.includes(value));
            } else if (swatch == swatches[swatches.length - 2]) {
              const firstOptionValue = swatches[0].querySelector('input:checked').value;
              return variant.options.includes(firstOptionValue);
            }
            return false;
          });

          // isolate values to disable for each option
          const otherOptionNumbers = optionNumbers.filter((optionNumber) => optionNumber !== swatchOptionNumber);
          const valuesToDisablePerOptionNumber = filteredUnavailableVariantsWithNewValue.reduce((accumulator, variant) => {
            for (const optionNumber of otherOptionNumbers) {
              const valueToDisable = variant[optionNumber];
              accumulator[optionNumber]
                ? accumulator[optionNumber].push(valueToDisable)
                : (accumulator[optionNumber] = [valueToDisable]);
            }
            return accumulator;
          }, {});

          // disable values that are not already checked
          for (const [optionNumber, valuesToDisable] of Object.entries(valuesToDisablePerOptionNumber)) {
            const swatchToChange = optionNumberToMap[optionNumber];
            const unchekedValuesToDisable = valuesToDisable.filter((value) =>
              this.querySelector(`input:not(:checked)[value="${value}"]`)
            );
            disableValuesInSwatch(swatchToChange, unchekedValuesToDisable);
          }
        });
      }

      // trigger option linking on load
      if (this.product) for (const swatch of swatches) swatch.dispatchEvent(new Event('change'));
    }

    resetOptions() {
      this.dataset.state = 'close';
      this.currentVariant = null;
      setTimeout(() => {
        for (let input of this.querySelectorAll('input')) {
          input.checked = false;
          input.disabled = false;
        }
        for (let [index, swatch] of this.querySelectorAll('[data-swatches-option]').entries()) {
          swatch.dataset.swatchesOption = index == 0 ? 'visible' : 'hidden';
        }
      }, 500);
    }
  }
  customElements.define('dynamic-swatches', DynamicSwatches);
}
